import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "../assets/desktop.css";
import { useParams } from "react-router-dom";
import { betGetHistoryAPI } from "../service/AuthService";
import moment from "moment";
export default function CurrentBets() {
  const { userId, marketId, eventId, sport } = useParams();
  const [data, setData] = React.useState([]);
  const getData = async () => {
    const { response } = await betGetHistoryAPI(
      {
        marketId,
        sport,
        userId
      }
    );
    setData(response);
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div _ngcontent-ng-c2192290883="" className="content">
      <router-outlet _ngcontent-ng-c2192290883="" />
      <app-profitloss-history _nghost-ng-c438177886="">
        <div _ngcontent-ng-c438177886="" className="main">
          <div
            _ngcontent-ng-c438177886=""
            className="animated fadeIn divider-top"
          >
            <div
              _ngcontent-ng-c438177886=""
              className="row"
              style={{ marginTop: 25 }}
            >
              <div
                _ngcontent-ng-c438177886=""
                className="col-sm-12 col-md-12 p-mobile-1"
              >
                <div
                  _ngcontent-ng-c438177886=""
                  className="card card-accent-primary"
                >
                  <div
                    _ngcontent-ng-c438177886=""
                    className="card-header account-detail-head"
                  >
                    {" "}
                    Bet History{" "}
                  </div>
                  <div
                    _ngcontent-ng-c438177886=""
                    className="card-body account-stat-body"
                  >
                    <div
                      _ngcontent-ng-c438177886=""
                      className="d-flex justify-content-end w-100 mb-2"
                    >
                      <div
                        _ngcontent-ng-c438177886=""
                        className="back indicators ms-1"
                      >
                        {" "}
                        Back{" "}
                      </div>
                      <div
                        _ngcontent-ng-c438177886=""
                        className="lay indicators ms-1"
                      >
                        {" "}
                        Lay{" "}
                      </div>
                      <div
                        _ngcontent-ng-c438177886=""
                        className="voidBet indicators ms-1"
                      >
                        {" "}
                        Void{" "}
                      </div>
                    </div>
                    <div _ngcontent-ng-c438177886="" className="row">
                      <div
                        _ngcontent-ng-c438177886=""
                        className="col-md-12 p-mobile-0"
                      >
                        <div
                          _ngcontent-ng-c438177886=""
                          className="table-responsive"
                        >
                          <table
                            _ngcontent-ng-c438177886=""
                            className="table table-bordered"
                          >
                            <thead _ngcontent-ng-c438177886="">
                              <tr _ngcontent-ng-c438177886="">
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  Sport Name{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                  style={{ minWidth: 200 }}
                                >
                                  Event Name{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                  style={{ minWidth: 120 }}
                                >
                                  Market Name{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                  style={{ minWidth: 120 }}
                                >
                                  Selection Name{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  Bet Type{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  User Price{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  Amount
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  Profit/Loss{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                  style={{ minWidth: 100 }}
                                >
                                  Place Date{" "}
                                </th>
                                <th
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                  style={{ minWidth: 100 }}
                                >
                                  Match Date{" "}
                                </th>
                              </tr>
                            </thead>
                            <tbody _ngcontent-ng-c438177886="">
                              {
                                data.map((item, index) => (
                                <tr _ngcontent-ng-c438177886="" className="back">
                                <td
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  {sport}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  aria-colindex={1}
                                  role="cell"
                                  className="text-center"
                                >
                                  {item.event_name}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                 {item.marketName? item.marketName : item?.runner_name}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  aria-colindex={2}
                                  role="cell"
                                  className="text-center"
                                >
                                  {item.runner_name}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  aria-colindex={3}
                                  role="cell"
                                  className="text-center"
                                >
                                      {
                                        item?.back_rate||item?.back_run? "Back" : "Lay"
                                  }
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  aria-colindex={4}
                                  role="cell"
                                  className="text-center"
                                >
                                  {" "}
                                      {
                                        
                                        item?.back_run||item?.lay_run
                                      }<span _ngcontent-ng-c438177886="">/{
                                        
                                        item?.back_rate||item?.lay_rate
                                  }</span>
                                  {/**/}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  aria-colindex={5}
                                  role="cell"
                                  className="text-center"
                                >
                                  {item?.amount}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  aria-colindex={6}
                                  role="cell"
                                  className="text-center"
                                >
                                  <span
                                    _ngcontent-ng-c438177886=""
                                    className="text-success"
                                  >
                                   {item?.profit}
                                  </span>
                                  {/**/}
                                  <span
                                    _ngcontent-ng-c438177886=""
                                    style={{ marginLeft: 5 }}
                                    className="text-danger"
                                  >
                                    {" "}
                                    (-{item?.loss}){" "}
                                  </span>
                                  {/**/}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  {moment(item?.created_date).format("DD-MM-YYYY HH:mm:ss")}
                                </td>
                                <td
                                  _ngcontent-ng-c438177886=""
                                  className="text-center"
                                >
                                  {moment(item?.created_date).format("DD-MM-YYYY HH:mm:ss")}
                                </td>
                              </tr>))}
                              {/**/}
                            </tbody>
                            {/**/}
                            {/**/}
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-profitloss-history>
      {/**/}
    </div>
  );
}
